import { YesNo } from 'store/ducks/globalTypes';

const newSolObj = (regId: number) => ({
  bru_id: regId,
  approver: '',
  evd_required: YesNo.YES,
  sol_desc: '',
  sol_type: ''
});

export default newSolObj;
